export enum ProductTypeEnum {
  Product = 0,
  Drug = 1,
}
